import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@mui/material';

function HostDomains(props) {
  const { host } = props;

  if (!host.sources.xrequest) {
    return null;
  }
  return (
          <Table>
            <TableBody>
              {Object.keys(host.sources.xrequest).sort((a, b) => a.localeCompare(b)).map((xreq) => (
                <TableRow
                  hover
                  key={xreq}
                >
                  <TableCell align="left">
                    {xreq}
                  </TableCell>
                  <TableCell align="right">
                    {host.sources.xrequest[xreq]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
  );
}

HostDomains.propTypes = {
  host: PropTypes.object.isRequired
};

export default HostDomains;
